/* Lídři (homepage) – přepínání tabů dle štítků.
 * Aktivuje se jen v [data-lidri-taby] (2+ skupin). Bez JS zůstane
 * viditelný první panel (ostatní mají atribut hidden ze šablony). */
(function () {
	function initLidriTaby(box) {
		var tabs = box.querySelectorAll('[data-lidri-tab]');
		var panels = box.querySelectorAll('[data-lidri-panel]');
		if (tabs.length < 2) return;

		function activate(index) {
			for (var i = 0; i < tabs.length; i++) {
				var on = tabs[i].getAttribute('data-lidri-tab') === String(index);
				tabs[i].classList.toggle('active', on);
				tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
			}
			for (var j = 0; j < panels.length; j++) {
				panels[j].hidden = panels[j].getAttribute('data-lidri-panel') !== String(index);
			}
		}

		for (var i = 0; i < tabs.length; i++) {
			(function (tab) {
				tab.addEventListener('click', function () {
					activate(tab.getAttribute('data-lidri-tab'));
				});
			})(tabs[i]);
		}
	}

	function init() {
		var boxes = document.querySelectorAll('[data-lidri-taby]');
		for (var i = 0; i < boxes.length; i++) initLidriTaby(boxes[i]);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
